import React from "react";
import { Link } from "react-router-dom";
import SignedinLInk from "./signedInLinks";
import SignedOutLink from "./signedOutLinks";
import SignedOut from "./signedOutLinks";
import { connect } from "react-redux";
const NavBar = (props) => {
  const { auth } = props;
  // const { name, initials } = props;
  // console.log(name + "\n" + initials);
  const links = auth.uid ? <SignedinLInk /> : <SignedOutLink />;
  return (
    <nav className="nav-wrapper grey darken-3">
      <div className="container">
        <Link to="/" className="brand-logo" style={{ left: "20px" }}>
          ALIVE
        </Link>
        {auth.isLoaded && links}
      </div>
    </nav>
  );
};
const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    name:
      state.firebase.profile["firstName"] +
      " " +
      state.firebase.profile["lastName"],
    initials: state.firebase.profile.initials,
  };
};
export default connect(mapStateToProps)(NavBar);
